export const currencyRates = {
  USD: 1,
  INR: 83, // Example: $1 = ₹83
};

export function convertCurrency(amount, from, to) {
  if (from === to) return amount;
  const inUSD = amount / currencyRates[from];
  return Math.round(inUSD * currencyRates[to]);
}